module.exports = __webpack_public_path__ + "static/media/logoH.106009af.svg";